import { render } from "./UploadImage.vue?vue&type=template&id=3e1bda9e"
import script from "./UploadImage.vue?vue&type=script&lang=js"
export * from "./UploadImage.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import BaseIcon from "@/components/BaseIcon.vue";
script.components = Object.assign({}, { BaseIcon }, script.components);